module.exports = __webpack_public_path__ + "img/120ne.e8d0a60b.svg";